import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    editing: {
        editMode: false,
        assignmentId: ""
    }
}

const assignmentSlice = createSlice({
    name: 'assignment',
    initialState,
    reducers: {
        startEditing: (state, action) => {
            state.editing.assignmentId = action.payload
            state.editing.editMode = true
        },
        endEditing: (state, action) => {
            state.editing.assignmentId = "";
            state.editing.editMode = false;
            
        } 
    }
})

export const {startEditing, endEditing} = assignmentSlice.actions;
export default assignmentSlice.reducer;